<template>
  <v-chip class="ml-12 text-body-2" width="100px" :color="chipColor">
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  name: 'ProductChip',
  props: {
    label: {
      type: String,
    },
    type: {
      type: String,
      default: function() {
        return 'warning'
      },
      validator: function(value) {
        return ['warning', 'error'].indexOf(value) > -1
      },
    },
  },
  computed: {
    chipColor() {
      return this.type === 'warning' ? '#FEF6CC' : 'rgb(223, 0, 36, 0.12)'
    },
  },
}
</script>

<style scoped lang="scss">
.v-chip {
  cursor: inherit;
}
</style>
